<template>
  <div class="intelligentLinkage_container">
    <div
      :class="{
        container_bg: true,
        container_green: curBG === 'typeGreen' ? true : false,
      }"
    >
      <img :src="getContainerBG" v-if="backgroundMask" />
    </div>
    <div class="overal_bg" v-if="curBG == 'typeDark'"></div>
    <div class="overal_bg_strong" v-if="curBG == 'typeStrong'"></div>
    <left-part :modelType="modelType" v-if="!isSetting && refreshTag && customerId != 36"></left-part>
    <right-part :modelType="modelType" v-if="!isSetting && refreshTag"></right-part>
    <setting style="z-index: 2" :modelType="modelType" v-if="isSetting"></setting>
    <heightLight />
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import leftPart from "@/modules/DIYcomponents/leftPart.vue";
import rightPart from "@/modules/DIYcomponents/rightPart.vue";
import setting from "@/modules/DIYcomponents/setting.vue";
import heightLight from "@/modules/IntelligentLinkageComponents/index.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { leftPart, rightPart, setting, heightLight },
  props: {},
  data() {
    //这里存放数据
    return {
      backgroundMask: bmeConfig.backgroundMask,
      customerId: this.$store.state.customerId,
      bme3dManagerLoaded: false,
      isSetting: false,
      hash: false,
      modelType: "IntelligentLinkageMod",
      styleType: bmeConfig.styleType,
      styleTypeMap: styleTypeMap,
      curBG: "",
      refreshTag: true,
      curMapType: "",
      loadedTimer: null,
      timer: null,
      mapObj: {},
      districtObj: {},
    };
  },
  computed: {
    getContainerBG: function () {
      let imgSrc = "";
      if (
        this.curBG &&
        this.styleTypeMap[this.curBG] &&
        this.styleTypeMap[this.curBG].dutyBG
      ) {
        imgSrc = require("@/views/MainMod/img/" + this.styleTypeMap[this.curBG].dutyBG);
      }
      if (!bmeConfig.backgroundMask) {
        imgSrc = "";
      }
      return imgSrc;
    },
    curBGVal: function () {
      return this.$store.state.curBG;
    },
    mapTypeVal() {
      return this.$store.state.mapType;
    },
  },
  //监控data中的数据变化
  watch: {
    hash: {
      handler(newVal, oldVal) {
        this.isSetting = newVal;
      },
      deep: true,
    },
    curBGVal: {
      handler(newVal, oldVal) {
        this.curBG = newVal;
      },
      deep: true,
    },
    mapTypeVal: {
      handler(newVal, oldVal) {
        this.curMapType = newVal;
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    reset() {
      this.modelType = "IntelligentLinkageMod";
      this.refreshTag = true;
    },
    reload() {
      let that = this;
      this.refreshTag = false;
      this.$nextTick(function () {
        that.reset();
        this.refreshTag = true;
      });
    },
    async isBme3dManagerLoaded() {
      if (bmeConfig.mapType !== "3D") return;
      if (window?.g_bme3dManager?.earth?.sceneTree) {
        let json = {
          title: "宝钢蒙层",
          ref: "bgPower",
          children: [],
        };
        let json2 = {
          title: "宝钢告警蒙层",
          ref: "bgAlertPower",
          children: [],
        };
        window?.g_bme3dManager.earth.sceneTree.root.children.push(json, json2);
        await this.drawAllMask();
        await this.getHeightLightBuildings();
      } else {
        if (this.loadedTimer) {
          clearTimeout(this.loadedTimer);
        }
        this.loadedTimer = setTimeout(() => {
          this.isBme3dManagerLoaded();
        }, 500);
      }
    },
    async drawAllMask() {
      let findLongitudeLatitudeListUrl =
        CONFIG.requestName + this.$apiOpt.findLongitudeLatitudeList;
      let res = await this.$apiUtils.get(findLongitudeLatitudeListUrl, {
        customerId: this.customerId, //42
      });
      if (res) {
        try {
          console.log("=======", res);
          let mapObj = {};
          res.forEach((item) => {
            if (!mapObj[item.id]) {
              mapObj[item.id] = {
                name: item.name,
                pos: [
                  (+item.longitude * Math.PI) / 180,
                  (+item.latitude * Math.PI) / 180,
                ],
              };
            } else {
              mapObj[item.id].pos.push(
                (+item.longitude * Math.PI) / 180,
                (+item.latitude * Math.PI) / 180
              );
            }
          });
          console.log("宝钢测试数据");
          console.log(mapObj);
          this.mapObj = mapObj;
          this.$store.commit("changeIntelligentMapObj", mapObj);
          /*for (let i in mapObj) {
            this.getMaskJson(i, mapObj[i]);
          }*/
        } catch (e) {
          console.log("e", e);
        }
      }
    },
    getMaskJson(ref, info) {
      let json = {
        ref: ref,
        czmObject: {
          xbsjType: "Polygon",
          enabled: false,
          xbsjGuid: "a7a97abc-455e-4f3f-a54a-d6efb5c220a4",
          name: info.name,
          positions: info.pos,
          height: 0,
          extrudedHeight: null,
          show: false,
          outline: {},
          ground: true,
        },
      };
      let json2 = {
        ref: `alert_${ref}`,
        czmObject: {
          xbsjType: "Polygon",
          enabled: false,
          xbsjGuid: "a7a97abc-455e-4f3f-a54a-d6efb5c220a4",
          name: info.name,
          positions: info.pos,
          height: 0,
          extrudedHeight: null,
          show: false,
          outline: {},
          ground: true,
        },
      };
      let json3 = {
        ref: `poi_${ref}`,
        czmObject: {
          xbsjType: "GeoPin",
          enabled: false,
          xbsjGuid: "d2e7f492-887a-45a7-af65-293a131d221a",
          name: info.name,
          evalString: "",
          position: [info.pos[0], info.pos[1], 50],
          far: 1073741824,
          innerHTML: `<!DOCTYPE HTML>\n<html>\n\n<head>\n    <title></title>\n    <style>\n        .textContain {\n            position: absolute;\n            height: 38px;\n            background-color: rgba(0, 0, 0, 0.8);\n            box-shadow: 0px 8px 16px 0px rgba(74, 144, 226, 0.31);\n            \nborder-radius: 2px;\nborder: 1px solid #4A90E2;\n            padding: 5px 10px ;\n            line-height:28px;\n            white-space: nowrap;\n            top: -15px;\n            left: -50px;\n            font-size: 18px;\n            border:0;      \n            color: #F5A623;\n        }\n    </style>\n</head>\n<body>\n    <div class="textContain">${info.name}</div>\n</body>\n\n</html>`,
        },
      };
      window?.g_bme3dManager?.earth?.sceneTree?.$refs?.bgPower?.children.push(
        json,
        json3
      );
      window?.g_bme3dManager?.earth?.sceneTree?.$refs?.bgAlertPower?.children.push(json2);
    },
    async getHeightLightBuildings() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.closeAllAlertColor();
      let districtUrl = CONFIG.requestName + this.$apiOpt.district;
      // let districtUrl = "http://screen.bmetech.com/screen/alarm/district";
      let res = await this.$apiUtils.get(districtUrl, {
        customerId: this.customerId, //42
        // startTime: "2022-01-02 21:20:44",
        // endTime: "2021-12-25 23:20:44",
        startTime: moment(new Date() - 3 * 60 * 1000).format("YYYY-MM-DD HH:mm:ss"),
        endTime: moment().format("YYYY-MM-DD HH:mm:ss"),
      });
      this.districtObj = res;
      //this.heightLightsRender();
      this.timer = setTimeout(() => {
        this.getHeightLightBuildings();
      }, 3 * 60 * 1000);
    },
    heightLightsRender() {
      if (this.districtObj) {
        try {
          this.districtObj.forEach((item) => {
            let buildItem =
              window?.g_bme3dManager?.earth?.sceneTree?.$refs[`alert_${item}`];
            if (buildItem) {
              buildItem.enabled = true;
              buildItem.czmObject.color = bmeConfig.bg_mark_color.markColor.nextMark;
              buildItem.czmObject.outline.color =
                bmeConfig.bg_mark_color.markOutColor.nextMark;
            }
            let poiItem = window?.g_bme3dManager?.earth?.sceneTree?.$refs[`poi_${item}`];
            if (poiItem) {
              poiItem.enabled = true;
            }
          });
        } catch (e) {
          console.log("e", e);
        }
      }
    },
    closeAllAlertColor() {
      let buildGroup =
        window.g_bme3dManager?.earth?.sceneTree?.$refs?.bgAlertPower?.children;
      buildGroup &&
        buildGroup.forEach((item) => {
          item.enabled = false;
        });
    },
    closeAllColor() {
      let buildGroup = window?.g_bme3dManager?.earth?.sceneTree?.$refs?.bgPower?.children;
      buildGroup &&
        buildGroup.forEach((item) => {
          item.enabled = false;
        });
      let alertGroup =
        window?.g_bme3dManager?.earth?.sceneTree?.$refs?.bgAlertPower?.children;
      alertGroup &&
        alertGroup.forEach((item) => {
          item.enabled = false;
        });
      window.currentODlineArr =
        window.currentODlineArr && window.currentODlineArr.destroy();
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.query && this.$route.query.setting == "true") {
      this.hash = true;
    } else {
      this.hash = false;
    }
    this.curMapType = this.$store.state.mapType;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.curBG = this.$store.state.curBG;
    this.isBme3dManagerLoaded();
  },
  unmounted() {
    this.closeAllColor();
    for (let key in window.g_bme3dManager.earth.sceneTree.$refs) { //回到首页，关闭所有的额外地图叶子节点
      window.g_bme3dManager.earth.sceneTree.$refs[key].enabled = false;
    }
  },
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.setting == "true") {
      this.hash = true;
    } else {
      this.hash = false;
    }
    this.reload();
  },
};
</script>
<style scoped>
.intelligentLinkage_container {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
}

.container_bg {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  z-index: -1;
}

.container_bg > img {
  filter: opacity(100%) grayscale(15%) blur(1px) contrast(95%) saturate(95%);
  width: 102%;
  height: 100%;
}

.container_green {
  filter: opacity(70%) grayscale(15%) blur(1px) contrast(95%) saturate(95%) !important;
}

.overal_bg {
  position: absolute;
  left: 15px;
  top: 120px;
  bottom: 15px;
  right: 15px;
  background-image: url("/static/images/common/overal.png");
  background-size: 100% 100%;
  background-repeat: "no-repeat";
  z-index: -1;
}
.overal_bg_strong {
  position: absolute;
  left: 15px;
  top: 120px;
  bottom: 15px;
  right: 15px;
  background-image: url("/static/images/common/overal.png");
  background-size: 100% 100%;
  background-repeat: "no-repeat";
  z-index: -1;
}

.changeSet {
  display: block;
  height: 100px;
  width: 100px;
  background: black;
  position: absolute;
  top: 0px;
  left: 0px;
  pointer-events: all;
}
</style>
